import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

// Enregistre les composants de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function AbsencesLineChart({ absences }) {
  // Ordre des mois (année scolaire)
  const schoolMonths = [9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7];

  // Noms des mois (français)
  const monthNames = {
    9: "Sept",
    10: "Oct",
    11: "Nov",
    12: "Déc",
    1: "Jan",
    2: "Fév",
    3: "Mar",
    4: "Avr",
    5: "Mai",
    6: "Juin",
    7: "Juil",
  };

  // Compter les absences par mois
  const absenceCounts = schoolMonths.map((month) =>
    absences.filter((a) => a.mois === month).length
  );

  const data = {
    labels: schoolMonths.map((m) => monthNames[m]),
    datasets: [
      {
        label: "Nombre d'absences",
        data: absenceCounts,
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.3)",
        fill: true,
        tension: 0.3, // rend la ligne courbée
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // 🔥 permet de gérer la taille via Tailwind
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Absences par mois (année scolaire)",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
      },
    },
  };
  return <div className=" h-60  bg-white rounded-xl shadow-md">
    <Line data={data} options={options} />
  </div>;
}
